import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'matchTime',
  standalone: false,
})
export class MatchTimePipe implements PipeTransform {
  transform({occurrence_minute = 0, occurrence_half = 0}): unknown {
    const timeAdded = occurrence_minute - 45;
    const halfStartTime = occurrence_half === 1 ? 45 : 90;

    return timeAdded > 0
      ? `${halfStartTime} + ${timeAdded}'`
      : `${occurrence_half === 1 ? occurrence_minute : 45 + occurrence_minute}'`;
  }
}
